module.exports = __webpack_public_path__ + "img/user_bg.f21b3688.png";